/**
 * API Configuration
 *
 * Centralized configuration for all API endpoints.
 * Change the base URL here to update it across the entire application.
 */

/**
 * Base URL for the AI API
 *
 * Development: http://localhost:8787
 * Production: https://your-worker-url.workers.dev
 */
export const AI_API_BASE_URL =
  import.meta.env.VITE_AI_API_URL ||
  'https://ug-district-gen-ai-api.edwin-m.workers.dev'

/**
 * AI API Endpoints
 */
export const AI_API_ENDPOINTS = {
  query: `${AI_API_BASE_URL}/query`,
  cachedQueries: `${AI_API_BASE_URL}/cached-queries`,
  cachedQuery: cacheKey => `${AI_API_BASE_URL}/cached-queries/${cacheKey}`,
  cacheStats: `${AI_API_BASE_URL}/cache-stats`,
  deleteCachedQuery: cacheKey =>
    `${AI_API_BASE_URL}/cached-queries/${cacheKey}`,
  checkDuplicate: `${AI_API_BASE_URL}/check-duplicate`,
}

/**
 * API Request timeout (in milliseconds)
 */
export const API_TIMEOUT = 30000 // 30 seconds

/**
 * Helper function to make API requests with timeout
 */
export async function fetchWithTimeout(
  url,
  options = {},
  timeout = API_TIMEOUT
) {
  const controller = new window.AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    })
    window.clearTimeout(id)
    return response
  } catch (error) {
    window.clearTimeout(id)
    if (error.name === 'AbortError') {
      throw new Error('Request timeout - please try again')
    }
    throw error
  }
}
